import React, {useState} from 'react';
import {ChevronDown, ChevronUp} from 'lucide-react';
import './QASection.css';  // Import the CSS file

import { CONTENT } from '../config/landingPageContent';

const QASection = ({ variant = 'default' }) => {
    const [openIndex, setOpenIndex] = useState(null);
    const content = CONTENT[variant] || CONTENT.default;

    const qaData = [
        {
            question: "How do I use ConvoCue?",
            answer: [
                "Download the app",
                "Complete the setup",
                "Add your experience and job description",
                content.qa.audio,
                "Get an answer in just 1 second"
            ]        },
        {
            question: "What is the difference between session and credit?",
            answer: "Credits never expire, while sessions expire when your subscription ends. If you have both, sessions will be used first."
        },
        {
            question: "Does it support questions in languages other than English?",
            answer: "Yes. You don't have to do any extra settings."
        },
        {
            question: "Is session summary available to download?",
            answer: content.qa.transcripts
        },
        {
            question: "Can I use it on Windows Laptop?",
            answer: "No, this version is for MAC only. You can join the community to get the earliest update in the future."
        },
        {
            question: "What is the cancellation policy?",
            answer: "You can cancel your subscription at any time. If you cancel, you'll retain access to the service until the end of your current billing period. We don't offer refunds for partial subscription periods."
        },
        {
            question: "What is the policy for the free trial?",
            answer: "We offer a free trial for the first 3 questions in each session. No credit card is required to start. It will let you choose to proceed after you reach the limit."
        },
        {
            question: "Which will be deducted first if I have both session and credits left?",
            answer: "Only the session left will be deducted."
        },
        {
            question: "Which domains/industries are supported by ConvoCue?",
            answer: "ConvoCue supports a wide range of industries including Software Engineering, Data Science, Machine Learning, Product management, Financial engineering and more. Our AI is trained on diverse datasets to provide relevant assistance across various professional domains."
        },
        {
            question: "What payment methods are available?",
            answer: "We accept all major credit cards (Visa, MasterCard, American Express, Discover), Link, CashApp, Alipay and Wechat pay."
        }, {
            question: "Is my payment information protected?",
            answer: "Yes. We use Stripe, a trusted and widely-used payment processor, to handle all transactions. Stripe ensures your payment information is encrypted and protected with advanced security measures, including PCI-DSS compliance."
        }
    ];

    const toggleQuestion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="qa-section">
            <h2>Questions & Answers</h2>
            <h3>If you still have questions. Here are the answers</h3>

            <div className="qa-list">
                {qaData.map((item, index) => (
                    <div key={index} className="qa-item">
                        <button
                            className="qa-question"
                            onClick={() => toggleQuestion(index)}
                        >
                            <span>{item.question}</span>
                            {openIndex === index ? (
                                <ChevronUp className="qa-icon" />
                            ) : (
                                <ChevronDown className="qa-icon" />
                            )}
                        </button>
                        {openIndex === index && (
                            <div className="qa-answer">
                                {index === 0 ? (
                                    <ul style={{ 
                                        listStyleType: 'disc', 
                                        paddingLeft: '1.5rem',
                                        marginTop: '0.5rem'
                                    }}>
                                        {item.answer.map((step, stepIndex) => (
                                            <li key={stepIndex} style={{ marginBottom: '0.5rem' }}>
                                                {step}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>{item.answer}</p>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QASection;